import React from "react";
import { useSelector } from "react-redux";

// import axios from "axios";

import "./TimeOverrunProjects.scss";

// Icons & Packages
import DropdownAngle from "assets/icons/dropdown-angle.svg";
import DropdownAngleLight from "assets/icons/dropdown-angle-light.svg";
import TORIcon from "assets/icons/time-overrun.svg";
import Construction from "assets/icons/construction-new.svg";
import Renovation from "assets/icons/renovation-new.svg";
import Support from "assets/icons/heart-new.svg";
import Transformation from "assets/icons/transformation-new.svg";
import TOIcon from "assets/icons/timeoverrun-new.svg";
import WalletBlue from "assets/icons/wallet-blue.svg";
import NoteSmallWhiteIcon from "assets/icons/notesmall-white.svg";
import NoteSmallWhiteIconLight from "assets/icons/notesmall-white-light.svg";
import TTCIcon from "assets/icons/ttc.svg";
import TTCIconLight from "assets/icons/ttc-light.svg";
import WatchIcon from "assets/icons/watch.svg";
import WatchIconLight from "assets/icons/watch-light.svg";

//imports loader gif
// import DashboardLoader from "assets/images/loader.gif";



const TimeOverrunProjects = () => {
  const selectedTheme = useSelector((state) => state.globalConfig.theme);
  return (
    <>
       {/* Dropdowns Wrapper */}
       <section className="dropdowns-wrapper">
            <div className="dropdown-container">
              {selectedTheme === "dark" ? (
                <img src={DropdownAngle} alt="#" />
              ) : (
                <img src={DropdownAngleLight} alt="#" />
              )}
              <select>
                <option>Central</option>
                <option>Option 2</option>
                <option>Option 3</option>
              </select>
            </div>
            <div className="dropdown-container">
              {selectedTheme === "dark" ? (
                <img src={DropdownAngle} alt="#" />
              ) : (
                <img src={DropdownAngleLight} alt="#" />
              )}
              <select>
                <option>Eastern</option>
                <option>Option 2</option>
                <option>Option 3</option>
              </select>
            </div>
            <div className="dropdown-container">
              <img src={DropdownAngle} alt="#" />
              <select>
                <option>North Western</option>
                <option>Option 2</option>
                <option>Option 3</option>
              </select>
            </div>
            <div className="dropdown-container">
              {selectedTheme === "dark" ? (
                <img src={DropdownAngle} alt="#" />
              ) : (
                <img src={DropdownAngleLight} alt="#" />
              )}
              <select>
                <option>Northern</option>
                <option>Option 2</option>
                <option>Option 3</option>
              </select>
            </div>
            <div className="dropdown-container">
              {selectedTheme === "dark" ? (
                <img src={DropdownAngle} alt="#" />
              ) : (
                <img src={DropdownAngleLight} alt="#" />
              )}
              <select>
                <option>S. Project</option>
                <option>Option 2</option>
                <option>Option 3</option>
              </select>
            </div>
            <div className="dropdown-container">
              {selectedTheme === "dark" ? (
                <img src={DropdownAngle} alt="#" />
              ) : (
                <img src={DropdownAngleLight} alt="#" />
              )}
              <select>
                <option>Southern</option>
                <option>Option 2</option>
                <option>Option 3</option>
              </select>
            </div>
          </section>

      {/* Timeoverrun Projects Pane */}
      <section className="timeoverrun-projects-wrapper">
        <div className="timeoverrun-projects-container">
          <div className="timeoverrun-title">
            <img src={TORIcon} alt="#" />
            <span>Time Overrun Projects</span>
          </div>
          <div className="timeoverrun-list">
            <ul>
              <li>
                <span>Western </span>
                <span>29%</span>
              </li>
              <li>
                <span>Northern East </span>
                <span>17.5%</span>
              </li>
              <li>
                <span>South West </span>
                <span>44.33%</span>
              </li>
              <li>
                <span>Western </span>
                <span>26.09%</span>
              </li>
              <li>
                <span>Northen East </span>
                <span>17.39%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Left Section Slice And Right Section Slice Info */}
      <section className="project-region-wrapper">
        <div className="left-side-region">
          <div className="top">
          <div className="timeoverrun-tile-projects-cover">
              <div className="icon-title">
                <div className="icon-cover">
                  <img src={TOIcon} alt="timeoverrunicon" />
                </div>
                <div className="tile-name">
                  <span>All Time Overrun</span>
                </div>
              </div>
              <div className="sp-count">
                <span>90</span>
              </div>
            </div>
            <div className="timeoverrun-tile-projects-cover">
              <div className="icon-title">
                <div className="icon-cover">
                  <img src={WalletBlue} alt="suspendedicon" />
                </div>
                <div className="tile-name">
                  <span>Budget</span>
                </div>
              </div>
              <div className="sp-count blue-count">
                <span>4.16bn</span>
                <span className="sp-currency">SAR</span>
              </div>
            </div>
          </div>
        </div>
        <div className="right-side-region">
          <div className="contract-status-wrapper">
            <div className="contract-status-container">
              <div className="header">
                <span>
                {selectedTheme === "dark" ? (
                        <img src={NoteSmallWhiteIcon} alt="#" />
                      ) : (
                        <img src={NoteSmallWhiteIconLight} alt="#" />
                      )}
                  Contract Status
                </span>
              </div>
              <div className="chart-container">
                <div className="chart-wrapper">
                  <div className="vertical-bar-container">
                    <div className="chart-system">
                      <span className="code">#</span>
                      <span className="currency">SAR</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>QASSAM</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">45%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "65%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>MAKKAH</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">81%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "81%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>RIYADH</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">32%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "32%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>MADINA</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">22%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "22%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>HAIL</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">36%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "36%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>NAJRAN</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">36%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "36%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>EASTERN</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">62%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "62%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>BAHA</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">54%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "54%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>AL-JOUF</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">45%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "45%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>ASIR</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">45%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "45%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>

                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>JAZAN</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">45%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "45%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>TABUK</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">45%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "45%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Progress Graph Section */}
      <section className="projects-progress-graph-wrapper">
        <div className="projects-progress-graph-container">
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalblue"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info darkblue">
              <div className="head">
                <span>
                  <img src={Construction} alt="#" />
                  Construction Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section">
                  <span>SAR</span>
                  <span>10.30 bn</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalgreen"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalgreen">
              <div className="head">
                <span>
                  <img src={Renovation} alt="#" />
                  Renovation Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white wastewater">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white wastewater">
                  <span>SAR</span>
                  <span>10.30 bn</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalorange"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalorange">
              <div className="head">
                <span>
                  <img src={Transformation} alt="#" />
                  Transformation Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white tse">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white tse">
                  <span>SAR</span>
                  <span>10.30 bn</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalblue"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalblue">
              <div className="head">
                <span>
                  <img src={Support} alt="#" />
                  Supportive Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white supportive">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white supportive">
                  <span>Projects</span>
                  <span>10.30 bn</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

       {/* Projects Contractor / Time Overrun Section */}
       <section className="contractor-timeoverrun-projects-wrapper">
        <div className="contractor-timeoverrun-projects-container">
          <div className="left">
            <div className="head">
              <span>
              {selectedTheme === "dark" ? (
                      <img src={TTCIcon} alt="#" />
                    ) : (
                      <img src={TTCIconLight} alt="#" />
                    )}
                Projects By Contractor
              </span>
            </div>
            <div className="body">
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Contractors</th>
                      <th>Projects</th>
                      <th>Budget (SAR)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ a نأ</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ a نأ</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ a نأ</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ a نأ</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ a نأ</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ a نأ</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="right">
            <div className="head">
              <span>
              {selectedTheme === "dark" ? (
                      <img src={WatchIcon} alt="#" />
                    ) : (
                      <img src={WatchIconLight} alt="#" />
                    )}
                Time Overrun Projects
              </span>
            </div>
            <div className="body">
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Cluster</th>
                      <th>Project Name</th>
                      <th>Budget (SAR)</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Northern</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                      <td>08-Feb-2019</td>
                      <td>23-Sep-2019</td>
                    </tr>
                    <tr>
                      <td>Northern</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                      <td>08-Feb-2019</td>
                      <td>23-Sep-2019</td>
                    </tr>
                    <tr>
                      <td>Northern</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                      <td>08-Feb-2019</td>
                      <td>23-Sep-2019</td>
                    </tr>
                    <tr>
                      <td>Northern</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                      <td>08-Feb-2019</td>
                      <td>23-Sep-2019</td>
                    </tr>
                    <tr>
                      <td>Northern</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                      <td>08-Feb-2019</td>
                      <td>23-Sep-2019</td>
                    </tr>
                    <tr>
                      <td>Northern</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                      <td>08-Feb-2019</td>
                      <td>23-Sep-2019</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TimeOverrunProjects;
